module.exports = __webpack_public_path__ + "static/media/bg7.6737ce3b.jpg";